import React from 'react';
import Flexbox from 'flexbox-react';
import { Link } from 'react-router-dom';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import messages from './messages';
import Wrapper from '../LandingBlockWrapper/BlockWrapper';
import Button from '../Button/index';

export default () => (
	<Wrapper className='Survey'>
		<Flexbox flexDirection='column'>
			<h2><FormattedMessage {...messages.title} /></h2>
			<p><FormattedHTMLMessage {...messages.subtitle} /></p>
			<Flexbox>
				<Link to='/survey'>
					<Button type='primary'><FormattedMessage {...messages.button} /></Button>
				</Link>
			</Flexbox>
		</Flexbox>
	</Wrapper>
);


// WEBPACK FOOTER //
// ./src/components/LandingSurvey/Survey.js